module.exports = __webpack_public_path__ + "img/copy.5087080c.png";